import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "../utils";

const agentMessageVariants = cva(
  "leading-snug max-w-xl [&_p+p]:mt-2 [&_ul]:mt-1 [&_ul]:mb-1 [&_li+li]:mt-0.5 [&_li_p]:m-0",
  {
    variants: {
      variant: {
        default: "",
        success: "",
        error: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const variantStyles = {
  default: "text-text-agent text-size-agent",
  success: "text-green-600 text-size-agent",
  error: "text-red-600 text-size-agent",
};

export function AgentMessage({
  children,
  className,
  variant = "default",
  ...props
}: ComponentProps<"div"> & VariantProps<typeof agentMessageVariants>) {
  return (
    <div
      className={
        cn(agentMessageVariants({ variant }), className) + ` ${variantStyles[variant || "default"]}`
      }
      data-role="agent-message"
      data-variant={variant}
      {...props}
    >
      {typeof children === "string" ? children.replace(/(\r\n|\r|\n){2,}/g, "$1") : children}
    </div>
  );
}

export function UserMessage({ children, className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "text-text-user text-size-user p-4 bg-user-bubble rounded-2xl max-w-xl self-end font-medium ml-auto w-fit",
        className,
      )}
      data-role="user-message"
      {...props}
    >
      {children}
    </div>
  );
}
